<!--
vData:传入数据
-->
<template>
  <div class="v-exhibitor-card" v-if="vData" @click.stop="details(vData)">
    <div class="v-card-head">
      <div class="v-collect pointer head-left">
        <span>{{ vData['matchingDegree'] }}</span>
      </div>
      <div class="v-collect pointer head-right" @click.stop="collect(vData)">
        <template v-if="showType === 'find' || showType === 'footprint'">
          <i class="iconfont" :class="{ 'iconshoucang-xuanzhong': vData['collected'], iconshoucang: !vData['collected'] }"></i>
          <span class="font-size-13">{{ vData['collected'] ? $t('collect[1]') : $t('collect[0]') }}</span>
        </template>
        <template v-if="showType === 'collection'">
          <i class="iconfont iconshoucang-xuanzhong theme-icon-primary-color"></i>
          <span class="font-size-13">{{ $t('collect[1]') }}</span>
        </template>
      </div>
    </div>
    <div class="v-exhibitor-header flex-start">
      <div class="img-box">
        <el-avatar :src="vData['headImage'] || vData['headPortrait'] || defImage('head')" :size="60"></el-avatar>
      </div>
      <div class="v-exhibitor-info">
        <div class="v-visitor-info">
          <span class="v-visitor-name">{{ vData['visitorName'] || vData['psjName'] }}</span>
          <span class="v-visitor-occupation">{{ vData['post'] || vData['psjRank'] }}</span>
        </div>
        <div class="v-visitor-company">{{ vData['corporateName'] || vData['psjComName'] }}</div>
      </div>
    </div>
    <div class="v-exhibitor-body text-left">
      <template v-for="(item, _index) in tagList">
        <span class="theme-label" :key="_index + '-' + index">{{ item }}</span>
        <br :key="_index" v-if="tagList.length >= 4 && _index === Math.ceil(tagList.length / 2) - 1" />
      </template>
    </div>
    <div class="v-exhibitor-footer flex-end font-size-14 align-center">
      <div class="pointer" @click.stop="msg(vData)">
        <span class="iconfont iconxiaoxi_weixuanzhong theme-icon-primary-color"></span>
        <span>{{ $t('message') }}</span>
      </div>
      <div class="pointer disabled" v-if="vData['invite']">
        <span class="iconfont iconyaoyue theme-icon-primary-color"></span>
        <span>{{ $t('finds.invited') }}</span>
      </div>
      <div class="pointer" @click.stop="invite(vData)" v-else>
        <span class="iconfont iconyaoyue theme-icon-primary-color"></span>
        <span>{{ $t('invite') }}</span>
      </div>
      <div class="pointer" @click.stop="details(vData)">
        <span class="el-icon-tickets theme-icon-primary-color"></span>
        <span>{{ $t('details') }}</span>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'

export default {
  props: {
    /* *
     * 组件显示的页面位置，
     * 找观众(find)/浏览记录(footprint)/我的收藏(collection)
     * */
    showType: {
      type: String,
      default: 'find'
    },
    vData: {},
    index: {
      type: Number,
      defualt: 0
    }
  },
  data() {
    return {
      swiperOption: {
        slidesPerView: 3,
        spaceBetween: 30,
        freeMode: true,
        pagination: {
          el: '.swiper-pagination',
          clickable: true
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        }
      },
      option: {
        imgW: '180px',
        imgH: '90px'
      },
      tagList: []
    }
  },
  computed: {
    ...mapGetters(['subjectType'])
  },
  created() {
    if (this.vData.questionList) {
      this.getTagList()
    }
  },
  methods: {
    //收藏
    collect(data) {
      if (this.showType === 'find') {
        let id = data.visitorId
        if (this.subjectType === 'ACTOR') {
          id = data.id || data.visitorId
        }
        this.$emit(
          'collect',
          {
            collectionId: data.collectionId || '',
            deleted: data.collected,
            collectionSubjectType: 'VISITOR',
            collectionSubjectId: id
          },
          this.index,
          data
        )
      }

      if (this.showType === 'collection') {
        this.$emit(
          'collect',
          {
            deleted: true,
            collectionSubjectType: 'VISITOR',
            collectionSubjectId: data.id
          },
          this.index
        )
      }

      if (this.showType === 'footprint') {
        this.$emit(
          'collect',
          {
            deleted: data.collected,
            collectionSubjectType: 'VISITOR',
            collectionSubjectId: data.visitorId
          },
          this.index,
          data
        )
      }
    },
    //邀约
    invite(data) {
        let id = data.visitorId || data.id
        if (this.subjectType === 'ACTOR') {
          id = data.id || data.visitorId
        }

        this.$emit(
          'invite',
          {
            projectId: data.projectId,
            userId: id
          },
          this.index,
          data
        )
    },
    //消息
    msg(data) {
      this.$emit('msg', data, this.index)
    },
    //详情
    details(data) {
      this.$emit('details', data)
    },

    getTagList() {
      let _tagList = []
      this.vData.questionList.forEach(item => {
        if (item.answerList.length > 0) {
          item.answerList.forEach(item2 => {
            let tagName2 = `${item2.aliasName}`

            if (item2.subAnswerList.length > 0) {
              item2.subAnswerList.forEach(item3 => {
                let tagName3 = `${item2.aliasName}: ${item3.aliasName}`
                _tagList.push(tagName3)
              })
            } else {
              _tagList.push(tagName2)
            }
          })
        }
      })
      this.tagList = _tagList
    }
  }
}
</script>
<style lang="stylus" scoped>
.v-exhibitor-card{
  padding-top:12px;
  margin-bottom: 24px;
  width:100%;
  background-color: $color-white;

  .v-exhibitor-header{
    margin-top: 15px;
    padding:0 12px;
    .v-exhibitor-info{
      flex: 1
      margin-top: 5px;
      margin-left:12px;
      overflow hidden

      .v-visitor-name {
        font-size: 16px;
      }

      .v-visitor-occupation{
        margin-left: 12px;
        font-size: 13px;
        color: $color-black-45
      }

      .v-visitor-company{
        margin-top: 8px;
        font-size: 13px;
        color: $color-black-45
        text-overflow: ellipsis;
        white-space nowrap
        overflow hidden
      }
    }
  }
  .v-exhibitor-body{
    padding:20px 12px 0 12px;
    margin-bottom: 8px;
    height 88px
    overflow hidden
    white-space: nowrap
    .theme-label{
      margin-left:0;
    }
  }
  .v-exhibitor-footer{
    padding: 0 12px;
    height: 44px;
    background: $color-gray-f5;

    *{
      line-height 20px
    }

    .iconfont{
      min-width 16px;
      font-size: 16px;
      vertical-align -1px;
    }

    >div{
      margin-left:25px;
    }
  }

  >>> .el-avatar > img {
    margin: 0 auto;
    height: 100%;
    width: 100%;
  }
}
.v-card-head{
  padding: 0 12px;
  overflow hidden

  .iconshoucang,
  .iconshoucang-xuanzhong{
    color: $color-main
    font-size: 16px;
  }

  *{
    line-height 16px;
    vertical-align top
  }

  .head-left{
    float: left;
    color: $color-blue-50
    font-size: 12px;
  }

  .head-right{
    float: right;
    font-size: 14px;
  }
}
</style>
